var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"appear":"","name":_vm.isMobile ? _vm.usedTransition : null,"mode":_vm.usedMode},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }